export default "__VITE_ASSET__CUB5yjnV__"